import { render } from "./DataTypes.vue?vue&type=template&id=0a1c7418"
import script from "./DataTypes.vue?vue&type=script&lang=js"
export * from "./DataTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/DataTypes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a1c7418"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a1c7418', __exports__)) {
    api.reload('0a1c7418', __exports__)
  }
  
  module.hot.accept("./DataTypes.vue?vue&type=template&id=0a1c7418", () => {
    api.rerender('0a1c7418', render)
  })

}


export default __exports__